import React, { useState } from "react";
import PropTypes from "prop-types";
import { Box, Flex, Text, List, Button } from "samba-ui";
import UserSinglePeriscopeDashboard from "./UserSinglePeriscopeDashboard";
import AddNewDashboardModal from "./AddNewDashboardModal";

const UserDashboardsList = ({
  dashboards,
  updateDashboardFilters,
  deleteDashboard,
  addNewDashboards
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const onClose = () => {
    setIsOpen(false);
  };
  const onSubmit = selectedDashboardsWithFilter => {
    selectedDashboardsWithFilter = selectedDashboardsWithFilter.reduce(
      (acc, { filters }) => {
        acc.push(filters.map(f => f.value));
        return acc;
      },
      []
    );

    setIsOpen(false);
    addNewDashboards(selectedDashboardsWithFilter);
  };
  return (
    <Box mt={3}>
      <List.Header borderColor="#d6d6d6 !important">
        <Flex justifyContent="space-between" alignItems="center">
          <Text fontSize={1} color="secondary">
            User's Dashboards
          </Text>
          <Button variant="primaryBordered" onClick={() => setIsOpen(true)}>
            + New Dashboard
          </Button>
        </Flex>
      </List.Header>
      {Object.keys(dashboards).map(key => (
        <UserSinglePeriscopeDashboard
          periscopeDashboard={dashboards[key]}
          updateDashboardFilters={updateDashboardFilters}
          deleteDashboard={() =>
            deleteDashboard(
              dashboards[key].userDashboardId,
              dashboards[key].dashboard.id
            )
          }
          key={key}
        />
      ))}
      {!Object.keys(dashboards).length && (
        <List.Empty>No assigned dashboards!</List.Empty>
      )}
      <AddNewDashboardModal
        isOpen={isOpen}
        onClose={onClose}
        onSubmit={onSubmit}
        userDashboards={dashboards}
      />
    </Box>
  );
};

UserDashboardsList.propTypes = {
  dashboards: PropTypes.object,
  updateDashboardFilters: PropTypes.func,
  deleteDashboard: PropTypes.func,
  addNewDashboards: PropTypes.func
};

export default UserDashboardsList;
